

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchParkGeofenceDetails,
//   deleteParkGeofence,
// } from "../redux/actions/parkGeofenceActions";
// import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";

// import Papa from "papaparse";
// import {
//   FiSearch,
//   FiDownload,
//   FiChevronLeft,
//   FiChevronRight,
// } from "react-icons/fi";
// import { GoogleMap, Polygon, useJsApiLoader } from "@react-google-maps/api";
// import theme from "../components/shared/theme";
// import {
//   dropdownStyle,
//   thStyle,
//   tdStyle,
//   paginationButtonStyle,
// } from "../components/shared/themeStyles";

// const containerStyle = { width: "100%", height: "45vh", maxHeight: "400px" };
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const ParkGeofence = () => {
//   const dispatch = useDispatch();

//   const { geofenceList, loading, error, pagination } = useSelector(
//     (state) => state.parkGeofence
//   );

//   const { districts, municipalities } = useSelector((state) => state.location);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedMunicipalityFilter, setSelectedMunicipalityFilter] =
//     useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedGeofence, setSelectedGeofence] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const itemsPerPage = 10; // backend limit

//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
//   });

//   // Load dropdown data + geofence list
//   useEffect(() => {
//     dispatch(fetchDistricts());
//     dispatch(fetchMunicipalities());
//   }, [dispatch]);

//   // Fetch API when filters or page change
//   useEffect(() => {
//     dispatch(
//       fetchParkGeofenceDetails(
//         currentPage,
//         itemsPerPage,
//         selectedDistrict,
//         selectedMunicipalityFilter
//       )
//     );
//   }, [dispatch, currentPage, selectedDistrict, selectedMunicipalityFilter]);

//   // Filter search only (not API)
//   const filteredList = geofenceList.filter((item) =>
//     item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const totalPages = pagination.totalPages || 1;


// const handleCSVDownload = async () => {
//   try {
//     const token = localStorage.getItem("token");

//     const query = new URLSearchParams({
//       page: 1,
//       limit: 20000,
//       districtId: selectedDistrict || "",
//       municipalityId: selectedMunicipalityFilter || "",
//       search: searchTerm || "",
//     }).toString();

//     const response = await fetch(
//       `${BASE_URL}/v1/api/parkGeofenceDetails?${query}`,
//       {
//         headers: { Authorization: token },
//       }
//     );

//     const json = await response.json();

//     if (!json.data || json.data.length === 0) {
//       alert("No data available to export");
//       return;
//     }

//     const rows = json.data.map((item) => ({
//       District: item.district_name || "-",
//       Municipality: item.municipality_name || "-",
//       Park: item.park_name || "-",
//       Description: item.description || "-",
//       Latitude: item.latitude || "-",
//       Longitude: item.longitude || "-",
//       Radius: item.radius_meters || "-",
//       GeofenceType: item.geofence_type || "-",
//       Status: item.status || "-",
//       CreatedAt: item.created_at
//         ? new Date(item.created_at).toLocaleString("en-IN")
//         : "-",
//       UpdatedAt: item.updated_at
//         ? new Date(item.updated_at).toLocaleString("en-IN")
//         : "-",
//     }));

//     const csv = Papa.unparse(rows);
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "park_geofence_list.csv";
//     link.click();
//   } catch (error) {
//     console.error("CSV Export Error:", error);
//   }
// };




  
//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this park geofence?")) {
//       dispatch(deleteParkGeofence(id));
//     }
//   };

//   const getPolygonPath = (polygonStr) => {
//     if (!polygonStr) return [];
//     return polygonStr
//       .replace("POLYGON((", "")
//       .replace("))", "")
//       .split(",")
//       .map((coord) => {
//         const [lng, lat] = coord.trim().split(" ");
//         return { lat: parseFloat(lat), lng: parseFloat(lng) };
//       });
//   };

//   return (
//     <div className="w-full min-h-screen bg-gray-100 p-4 md:p-6 overflow-x-auto">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
//           Park Geofence
//         </h1>
//       </div>

//       {/* Filters */}
//       <div className="flex flex-wrap gap-3 items-center bg-white p-4 rounded-lg shadow mb-6">
        
//         {/* District Filter */}
//         <select
//           value={selectedDistrict}
//           onChange={(e) => {
//             setSelectedDistrict(e.target.value);
//             setCurrentPage(1);
//           }}
//           style={dropdownStyle}
//         >
//           <option value="">All Districts</option>
//           {districts?.map((d) => (
//             <option key={d.id} value={d.id}>
//               {d.name}
//             </option>
//           ))}
//         </select>

//         {/* Municipality Filter */}
//         <select
//           value={selectedMunicipalityFilter}
//           onChange={(e) => {
//             setSelectedMunicipalityFilter(e.target.value);
//             setCurrentPage(1);
//           }}
//           style={dropdownStyle}
//         >
//           <option value="">All Municipalities</option>
//           {municipalities?.map((m) => (
//             <option key={m.id} value={m.id}>
//               {m.name}
//             </option>
//           ))}
//         </select>

//         {/* Search */}
//         <div className="relative w-full sm:w-[260px]">
//           <FiSearch className="absolute left-3 top-3 text-gray-500" />
//           <input
//             type="text"
//             placeholder="Search by park name..."
//             value={searchTerm}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setCurrentPage(1);
//             }}
//             style={{ ...dropdownStyle, paddingLeft: theme.spacing.xl }}
//           />
//         </div>

//         <button
//           onClick={handleCSVDownload}
//           className="ml-auto bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//         >
//           <FiDownload /> Export CSV
//         </button>
//       </div>

//       {/* Table */}
//       {loading ? (
//         <p className="text-gray-700">Loading...</p>
//       ) : error ? (
//         <p className="text-red-600">Error: {error}</p>
//       ) : filteredList.length > 0 ? (
//         <div className="overflow-x-auto bg-white rounded-lg shadow">
//           <table className="min-w-[900px] w-full text-sm text-left">
//             <thead className="bg-gray-800 text-white">
//               <tr>
//                 <th style={thStyle}>#</th>
//                 <th style={thStyle}>Park</th>
//                 <th style={thStyle}>District</th>
//                 <th style={thStyle}>Municipality</th>
//                 <th style={thStyle}>Latitude</th>
//                 <th style={thStyle}>Longitude</th>
//                 <th style={tdStyle}>Radius (m)</th>
//                 <th style={thStyle}>Geofence Type</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {filteredList.map((item, index) => (
//                 <tr key={item.id}>
//                   <td style={tdStyle}>
//                     {(currentPage - 1) * itemsPerPage + index + 1}
//                   </td>
//                   <td style={tdStyle}>{item.park_name}</td>
//                   <td style={tdStyle}>{item.district_name}</td>
//                   <td style={tdStyle}>{item.municipality_name}</td>
//                   <td style={tdStyle}>{item.latitude}</td>
//                   <td style={tdStyle}>{item.longitude}</td>
//                   <td style={tdStyle}>{item.radius_meters}</td>
//                   <td style={tdStyle}>{item.geofence_type}</td>
//                   <td style={tdStyle}>{item.status}</td>
//                   <td className="flex gap-2 p-2">
//                     <button
//                       onClick={() => {
//                         setSelectedGeofence(item);
//                         setIsModalOpen(true);
//                       }}
//                       className="bg-blue-600 text-white px-3 py-1 rounded text-xs"
//                     >
//                       View Polygon
//                     </button>
//                     <button
//                       onClick={() => handleDelete(item.id)}
//                       className="bg-red-200 text-red-700 px-3 py-1 rounded text-xs"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="flex justify-between items-center p-4 border-t bg-gray-50">
//             <button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               style={paginationButtonStyle}
//             >
//               <FiChevronLeft /> Previous
//             </button>

//             <p className="text-sm">
//               Page {currentPage} of {totalPages}
//             </p>

//             <button
//               onClick={() =>
//                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//               }
//               disabled={currentPage === totalPages}
//               style={paginationButtonStyle}
//             >
//               Next <FiChevronRight />
//             </button>
//           </div>
//         </div>
//       ) : (
//         <p className="text-gray-600 mt-4">No park geofences found.</p>
//       )}

//       {/* Geofence Map Modal */}
//       {isModalOpen && selectedGeofence && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
//           <div className="bg-white rounded-lg w-[95%] max-w-xl p-4 relative max-h-[90vh] overflow-auto">
//             <h2 className="text-lg font-bold mb-4">
//               {selectedGeofence.park_name}
//             </h2>
//             <button
//               onClick={() => setIsModalOpen(false)}
//               className="absolute top-2 right-2 text-red-600 font-bold text-xl"
//             >
//               ✕
//             </button>

//             {isLoaded && selectedGeofence.geofence_polygon ? (
//               <GoogleMap
//                 mapContainerStyle={containerStyle}
//                 center={getPolygonPath(selectedGeofence.geofence_polygon)[0]}
//                 zoom={18}
//               >
//                 <Polygon
//                   paths={getPolygonPath(selectedGeofence.geofence_polygon)}
//                   options={{
//                     fillColor: "#FF0000",
//                     fillOpacity: 0.35,
//                     strokeColor: "#FF0000",
//                     strokeOpacity: 0.8,
//                     strokeWeight: 2,
//                   }}
//                 />
//               </GoogleMap>
//             ) : (
//               <p className="text-gray-700">Loading map...</p>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ParkGeofence;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchParkGeofenceDetails,
  deleteParkGeofence,
} from "../redux/actions/parkGeofenceActions";
import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";

import Papa from "papaparse";
import {
  FiSearch,
  FiDownload,
  FiChevronLeft,
  FiChevronRight,
  FiX,
} from "react-icons/fi";
import { GoogleMap, Polygon, useJsApiLoader } from "@react-google-maps/api";
import theme from "../components/shared/theme";
import {
  dropdownStyle,
  thStyle,
  tdStyle,
  paginationButtonStyle,
} from "../components/shared/themeStyles";

const containerStyle = { width: "100%", height: "45vh", maxHeight: "400px" };
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ParkGeofence = () => {
  const dispatch = useDispatch();

  const { geofenceList, loading, error, pagination } = useSelector(
    (state) => state.parkGeofence
  );

  const { districts, municipalities } = useSelector((state) => state.location);

  // Filter states
  const [searchTerm, setSearchTerm] = useState(""); // Combined search for project_code and park_name
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [selectedProjectType, setSelectedProjectType] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedGeofence, setSelectedGeofence] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const itemsPerPage = 10; // backend limit

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
  });

  // Load dropdown data
  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  // Fetch API when filters or page change
  useEffect(() => {
    dispatch(
      fetchParkGeofenceDetails(
        currentPage,
        itemsPerPage,
        selectedDistrict,
        selectedMunicipality,
        searchTerm,
        selectedProjectType
      )
    );
  }, [dispatch, currentPage, selectedDistrict, selectedMunicipality, searchTerm, selectedProjectType]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedDistrict, selectedMunicipality, searchTerm, selectedProjectType]);

  const totalPages = pagination.totalPages || 1;

  // Handle CSV Download with all filters
  const handleCSVDownload = async () => {
    try {
      const token = localStorage.getItem("token");

      const query = new URLSearchParams({
        page: 1,
        limit: 20000,
        districtId: selectedDistrict || "",
        municipalityId: selectedMunicipality || "",
        search: searchTerm || "",
        project_type: selectedProjectType || "",
      }).toString();

      const response = await fetch(
        `${BASE_URL}/v1/api/parkGeofenceDetails?${query}`,
        {
          headers: { Authorization: token },
        }
      );

      const json = await response.json();

      if (!json.data || json.data.length === 0) {
        alert("No data available to export");
        return;
      }

      const rows = json.data.map((item) => ({
        "Project Code": item.project_code || "-",
        "Project Type": item.project_type || "-",
        "Park Name": item.park_name || "-",
        "Description": item.description || "-",
        "District": item.district_name || "-",
        "Municipality": item.municipality_name || "-",
        "Ward": item.ward || "-",
        "Park Stretch Name": item.park_stretch_name || "-",
        "Latitude": item.latitude || "-",
        "Longitude": item.longitude || "-",
        "Radius (m)": item.radius_meters || "-",
        "Geofence Type": item.geofence_type || "-",
        "Status": item.status || "-",
        "Created At": item.created_at
          ? new Date(item.created_at).toLocaleString("en-IN")
          : "-",
        "Updated At": item.updated_at
          ? new Date(item.updated_at).toLocaleString("en-IN")
          : "-",
      }));

      const csv = Papa.unparse(rows);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `park_geofence_${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
    } catch (error) {
      console.error("CSV Export Error:", error);
      alert("Failed to export CSV");
    }
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this park geofence?")) {
      dispatch(deleteParkGeofence(id));
    }
  };

  const getPolygonPath = (polygonStr) => {
    if (!polygonStr) return [];
    return polygonStr
      .replace("POLYGON((", "")
      .replace("))", "")
      .split(",")
      .map((coord) => {
        const [lng, lat] = coord.trim().split(" ");
        return { lat: parseFloat(lat), lng: parseFloat(lng) };
      });
  };

  // Clear all filters
  const clearFilters = () => {
    setSearchTerm("");
    setSelectedDistrict("");
    setSelectedMunicipality("");
    setSelectedProjectType("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 p-4 md:p-6 overflow-x-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
          Park Geofence Management
        </h1>
      </div>

      {/* Filters Section */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="flex flex-wrap gap-3 items-center">
          {/* Combined Search */}
          <div className="relative w-full sm:w-[300px]">
            <FiSearch className="absolute left-3 top-3 text-gray-500" />
            <input
              type="text"
              placeholder="Search by project code or park name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ ...dropdownStyle, paddingLeft: theme.spacing.xl }}
              className="w-full"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm("")}
                className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
              >
                <FiX />
              </button>
            )}
          </div>

          {/* Project Type Filter */}
          <select
            value={selectedProjectType}
            onChange={(e) => setSelectedProjectType(e.target.value)}
            style={dropdownStyle}
            className="min-w-[150px]"
          >
            <option value="">All Project Types</option>
            <option value="Park">Park</option>
            <option value="Stretch">Stretch</option>
            <option value="Shelter">Shelter</option>
          </select>

          {/* District Filter */}
          <select
            value={selectedDistrict}
            onChange={(e) => setSelectedDistrict(e.target.value)}
            style={dropdownStyle}
            className="min-w-[180px]"
          >
            <option value="">All Districts</option>
            {districts?.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>

          {/* Municipality Filter */}
          <select
            value={selectedMunicipality}
            onChange={(e) => setSelectedMunicipality(e.target.value)}
            style={dropdownStyle}
            className="min-w-[180px]"
          >
            <option value="">All Municipalities</option>
            {municipalities?.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>

          {/* Clear Filters Button */}
          {(searchTerm || selectedDistrict || selectedMunicipality || selectedProjectType) && (
            <button
              onClick={clearFilters}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
            >
              Clear Filters
            </button>
          )}

          {/* Export CSV Button */}
          <button
            onClick={handleCSVDownload}
            className="ml-auto bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2 hover:bg-blue-700 transition-colors"
            disabled={loading || geofenceList.length === 0}
          >
            <FiDownload /> Export CSV
          </button>
        </div>

        {/* Active Filters Display */}
        {(searchTerm || selectedProjectType || selectedDistrict || selectedMunicipality) && (
          <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-gray-200">
            <span className="text-sm text-gray-600">Active Filters:</span>
            {searchTerm && (
              <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full flex items-center gap-1">
                Search: {searchTerm}
                <button onClick={() => setSearchTerm("")} className="hover:text-blue-600">
                  <FiX size={14} />
                </button>
              </span>
            )}
            {selectedProjectType && (
              <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full flex items-center gap-1">
                Type: {selectedProjectType}
                <button onClick={() => setSelectedProjectType("")} className="hover:text-green-600">
                  <FiX size={14} />
                </button>
              </span>
            )}
            {selectedDistrict && (
              <span className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full flex items-center gap-1">
                District: {districts.find(d => d.id === selectedDistrict)?.name}
                <button onClick={() => setSelectedDistrict("")} className="hover:text-purple-600">
                  <FiX size={14} />
                </button>
              </span>
            )}
            {selectedMunicipality && (
              <span className="bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full flex items-center gap-1">
                Municipality: {municipalities.find(m => m.id === selectedMunicipality)?.name}
                <button onClick={() => setSelectedMunicipality("")} className="hover:text-orange-600">
                  <FiX size={14} />
                </button>
              </span>
            )}
          </div>
        )}
      </div>

      {/* Results Summary */}
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-gray-600">
          Showing {geofenceList.length} of {pagination.totalRecords || 0} records
        </p>
      </div>

      {/* Table - Removed Latitude, Longitude, and Geofence Type columns */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      ) : error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          Error: {error}
        </div>
      ) : geofenceList.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
          <table className="min-w-[1000px] w-full text-sm text-left">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Project Code</th>
                <th style={thStyle}>Project Type</th>
                <th style={thStyle}>Park Name</th>
                <th style={thStyle}>District</th>
                <th style={thStyle}>Municipality</th>
                <th style={thStyle}>Ward</th>
                <th style={thStyle}>Radius (m)</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {geofenceList.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td style={tdStyle}>
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td style={tdStyle} className="font-mono text-xs">
                    {item.project_code}
                  </td>
                  <td style={tdStyle}>
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      item.project_type === 'Park' ? 'bg-green-100 text-green-800' :
                      item.project_type === 'Stretch' ? 'bg-blue-100 text-blue-800' :
                      'bg-purple-100 text-purple-800'
                    }`}>
                      {item.project_type}
                    </span>
                  </td>
                  <td style={tdStyle} className="max-w-[250px] truncate" title={item.park_name}>
                    {item.park_name}
                  </td>
                  <td style={tdStyle}>{item.district_name}</td>
                  <td style={tdStyle}>{item.municipality_name}</td>
                  <td style={tdStyle}>{item.ward || '-'}</td>
                  <td style={tdStyle}>{item.radius_meters}</td>
                  <td style={tdStyle}>
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {item.status}
                    </span>
                  </td>
                  <td className="flex gap-2 p-2">
                    <button
                      onClick={() => {
                        setSelectedGeofence(item);
                        setIsModalOpen(true);
                      }}
                      className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 transition-colors"
                    >
                      View Map
                    </button>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="bg-red-200 text-red-700 px-3 py-1 rounded text-xs hover:bg-red-300 transition-colors"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center p-4 border-t bg-gray-50">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={paginationButtonStyle}
              className="flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FiChevronLeft /> Previous
            </button>

            <div className="flex items-center gap-2">
              <p className="text-sm text-gray-700">
                Page {currentPage} of {totalPages}
              </p>
              <span className="text-sm text-gray-500">
                (Total: {pagination.totalRecords} records)
              </span>
            </div>

            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={paginationButtonStyle}
              className="flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next <FiChevronRight />
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <p className="text-gray-600">No park geofences found matching your criteria.</p>
          <button
            onClick={clearFilters}
            className="mt-4 text-blue-600 hover:text-blue-800 underline"
          >
            Clear all filters
          </button>
        </div>
      )}

      {/* Geofence Map Modal - Latitude, Longitude, and Geofence Type are still shown here for reference */}
      {isModalOpen && selectedGeofence && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
          <div className="bg-white rounded-lg w-[95%] max-w-3xl p-4 relative max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="text-lg font-bold">{selectedGeofence.park_name}</h2>
                <p className="text-sm text-gray-600">
                  {selectedGeofence.project_code} | {selectedGeofence.project_type}
                </p>
              </div>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-red-600 font-bold text-xl hover:text-red-800"
              >
                ✕
              </button>
            </div>

            {isLoaded && selectedGeofence.geofence_polygon ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={getPolygonPath(selectedGeofence.geofence_polygon)[0]}
                zoom={18}
                options={{
                  mapTypeControl: true,
                  streetViewControl: true,
                  fullscreenControl: true,
                }}
              >
                <Polygon
                  paths={getPolygonPath(selectedGeofence.geofence_polygon)}
                  options={{
                    fillColor: "#FF0000",
                    fillOpacity: 0.35,
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                  }}
                />
              </GoogleMap>
            ) : (
              <div className="h-[400px] flex items-center justify-center bg-gray-100">
                <p className="text-gray-700">Loading map...</p>
              </div>
            )}

            <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
              <div>
                <p><span className="font-semibold">Latitude:</span> {selectedGeofence.latitude}</p>
                <p><span className="font-semibold">Longitude:</span> {selectedGeofence.longitude}</p>
                <p><span className="font-semibold">Radius:</span> {selectedGeofence.radius_meters}m</p>
                <p><span className="font-semibold">Geofence Type:</span> {selectedGeofence.geofence_type}</p>
              </div>
              <div>
                <p><span className="font-semibold">District:</span> {selectedGeofence.district_name}</p>
                <p><span className="font-semibold">Municipality:</span> {selectedGeofence.municipality_name}</p>
                <p><span className="font-semibold">Ward:</span> {selectedGeofence.ward || 'N/A'}</p>
                <p><span className="font-semibold">Status:</span> {selectedGeofence.status}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParkGeofence;